import { ProfileDto } from '../dto/profile-dto';
import { Profile } from '../models/profile-model';

export function profileFromDto(dto: ProfileDto): Profile {
  return {
    id: dto.id,
    name: dto.name,
    email: dto.email,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
  };
}
